import getPageName from './getPageName';

const site = () => {
  seeAllFaq();
  seeAllProgramm();
  initFilters();
  advCaceProgram();

  // Collapse blocks
  if (window.innerWidth <= 767) {
    collapseList(
      '.footer-item__list--1',
      '.footer-item__list-head',
      '.footer-item__list-collapse',
      '.footer-item__list-icon'
    );
    collapseList(
      '.footer-item__list--2',
      '.footer-item__list-head',
      '.footer-item__list-collapse',
      '.footer-item__list-icon'
    );
    collapseList(
      '.footer-item__list--3',
      '.footer-item__list-head',
      '.footer-item__list-collapse',
      '.footer-item__list-icon'
    );
    collapseList(
      '.footer-item__list--4',
      '.footer-item__list-head',
      '.footer-item__list-collapse',
      '.footer-item__list-icon'
    );
    collapseList(
      '.program__blocks',
      '.programBlock__top',
      '.programBlock__right',
      '.programBlock__icon'
    );
  }

  //Кнопки смотреть все
  function seeAllFaq() {
    let btn_viewAll = document.querySelector('.faqBlock__button');
    let blocks = document.querySelectorAll('.faq__block');

    blocks.forEach((item, index) => {
      blocks[index].style.height = 0;
      blocks[index].style.border = 'none';

      for (var i = 0; i < 5; i++) {
        blocks[i].removeAttribute('style');
      }

      btn_viewAll?.addEventListener('click', function () {
        if (blocks[index].hasAttribute('style')) {
          blocks[index].removeAttribute('style');
          btn_viewAll.textContent = 'Свернуть все';
          btn_viewAll.classList.add('active');
        } else {
          blocks[index].style.display = 'none';

          for (var i = 0; i < 5; i++) {
            blocks[i].removeAttribute('style');
          }

          blocks[0].scrollIntoView();
          btn_viewAll.textContent = 'Развернуть все вопросы';
          btn_viewAll.classList.remove('active');
        }
      });
    });
  }

  // Плавный скролл
  function setNavigation() {
    $("a[href^='#']:not(.employment-formats__btn):not([rel='modal:open'])").on(
      'click',
      function (e) {
        e.preventDefault();
        $('html,body')
          .stop()
          .animate(
            {
              scrollTop: $(`#${this.href.split('#').pop()}`).offset().top,
            },
            700
          );
      }
    );
  }

  $(function () {
    setNavigation();
  });

  // Collapse
  function collapseList(wrapper, btns, collapse, icon) {
    let wrap = document.querySelector(wrapper);

    if (wrap) {
      let buttons = wrap.querySelectorAll(btns),
        blockCollapseHeights = [],
        collapseBlock = wrap?.querySelectorAll(collapse);

      buttons.forEach((item, i) => {
        if (collapseBlock[i]) {
          blockCollapseHeights.push(collapseBlock[i].clientHeight);
          collapseBlock[i].style.height = 0;

          item.addEventListener('click', (e) => {
            e.stopImmediatePropagation();

            if (collapseBlock[i].style.height == 0 + 'px') {
              collapseBlock[i].style.height = blockCollapseHeights[i] + 'px';
              item.querySelector(icon).classList.add('rotate');
            } else {
              collapseBlock[i].style.height = 0;
              item.querySelector(icon).classList.remove('rotate');
            }
          });
        }
      });
    }
  }

  //Кнопки смотреть все
  function seeAllProgramm() {
    let btn_viewAll = document.querySelector('.program__button'),
      blocks = document.querySelectorAll('.program__block'),
      quantity = blocks.length;


    blocks.forEach((item, index) => {

      if (window.innerWidth > 767) {
        item.style.height = item.offsetHeight + 'px';
      }

      if (index > 2) {
        item.style.height = '0';
      }

      if (index >= 3 && index <= quantity) {
        item.style.borderTop = 'none';
      }

      btn_viewAll?.addEventListener('click', function () {
        if (item.hasAttribute('style')) {
          item.removeAttribute('style');

          btn_viewAll.textContent = 'Свернуть все';
          btn_viewAll.classList.add('active');
        } else {

          if (window.innerWidth > 767) {
            item.style.height = item.offsetHeight + 'px';
            blocks[2].style.borderBottom = '1px solid #1f1f1f';
          }

          if (index > 2) {
            item.style.display = 'none';
          }

          blocks[0].scrollIntoView({
            behavior: 'smooth',
          });

          btn_viewAll.textContent = 'Развернуть всю программу';
          btn_viewAll.classList.remove('active');
        }
      });
    });
  }

  /* Реализация показа/скрытия баннера */
  (() => {
    const banner = document.querySelector('[data-banner]');
    
    if (!banner) return;
    const header = document.querySelector('.header');
    const form = document.querySelector('#form');

    const trackScroll = () => {
      if (getPageName() === 'main-page' && window.innerWidth < 768) return;
      const scrolled = window.pageYOffset;
      if (scrolled < header.offsetTop + header.clientHeight) {
        banner.style.transform = 'translateY(207%)';
      } else if (
        scrolled + document.documentElement.clientHeight >
        form.offsetTop
      ) {
        banner.style.transform = 'translateY(207%)';
      } else if (scrolled < form.offsetTop) {
        banner.style.transform = 'translateY(0%)';
      }
    };
    window.addEventListener('scroll', trackScroll);
  })();

  //Показать / скрыть текст в блоке .talk
  (() => {
    const contents = document.querySelectorAll('.talk-item_text p');
    const btns = document.querySelectorAll('.talk-item_link');
    const textBtn = document.querySelectorAll('.talk-item_link');

    btns.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (contents[index].getAttribute('aria-hidden') == 'false') {
          contents[index].setAttribute('aria-hidden', 'true');
          contents[index].classList.add('hide');
          textBtn[index].textContent = 'Читать далее';
        } else {
          contents[index].setAttribute('aria-hidden', 'false');
          contents[index].classList.remove('hide');
          textBtn[index].textContent = 'Свернуть';
        }
      });
    });
  })();

  // Фильтрация каталог программ
  function initFilters() {
    const filters = document.querySelectorAll('[data-filter]');
    const items = document.querySelectorAll('[data-filter-item]');
    initShowMoreButton('.catalog', 8);

    let active = document.querySelector('.active[data-filter]');

    filters.length &&
      items.length &&
      filters.forEach((filter) => {
        filter.addEventListener('click', () => {
          let direction = filter.getAttribute('data-direction');

          filter.classList.add('active');
          active.classList.remove('active');
          active = filter;

          items.forEach((item) => {
            switch (direction) {
              case 'all':
                item.style.display = 'flex';
                break;
              case item.getAttribute('data-direction'):
                item.style.display = 'flex';
                break;
              default:
                item.style.display = 'none';
                break;
            }
          });

          initShowMoreButton('.catalog', 8);
        });
      });
  }

  // Функция для инициализации кнопки Показать ещё.
  // При вызове аргументами передаются селектор блока, в котором нужен данный функционал, а также количество элементов, видимых изначально. Например, initShowMoreButton('.program', 4);
  // При вёрстке кнопке добавить класс .show-button для стилизации, если нужны специфические стили для кнопки, то стилизовать каскадом от родителя. Например,
  //    .program {
  //       .show-button {
  //          ...
  //       }
  //    }
  // Также кнопке ОБЯЗАТЕЛЬНО добавить атрибут data-show-button
  // Также ОБЯЗАТЕЛЬНО добавить атрибут data-collapse-item всем элементам из раскрывающегося списка, даже если они видимы изначально

  function initShowMoreButton(container, visibleItems) {
    const itemsContainer = document.querySelector(container);
    if (!itemsContainer) return;
    const showMoreButton = itemsContainer.querySelector('[data-show-button]');
    const items = Array.from(
      itemsContainer.querySelectorAll('[data-collapse-item]')
    ).filter((item) => item.style.display !== 'none');

    // Обнуление перед переинициализацией
    items.forEach((item) => {
      item.style.display = null;
      item.style.opacity = 1;
    });

    if (showMoreButton) {
      showMoreButton.classList.remove('hidden');
      showMoreButton.textContent = 'Показать еще';
    }

    if (items.length <= visibleItems) {
      showMoreButton?.classList.add('hidden');
      return;
    }

    const hiddenItems = items.slice(visibleItems);
    hiddenItems.forEach((item) => {
      item.style.display = 'none';
      item.style.opacity = 0;
    });

    const onShowMoreButtonClick = () => {
      hiddenItems.forEach((item) => {
        item.style.display = null;
        setTimeout(() => {
          item.style.opacity = 1;
        });
      });
      showMoreButton.textContent = 'Свернуть';
      showMoreButton.removeEventListener('click', onShowMoreButtonClick);
      showMoreButton.addEventListener('click', onCollapseButtonClick);
    };

    const onCollapseButtonClick = () => {
      hiddenItems.forEach((item) => {
        setTimeout(() => {
          item.style.display = 'none';
        }, 250);
        item.style.opacity = 0;
      });
      showMoreButton.textContent = 'Показать еще';
      showMoreButton.removeEventListener('click', onCollapseButtonClick);
      showMoreButton.addEventListener('click', onShowMoreButtonClick);
    };

    showMoreButton?.addEventListener('click', onShowMoreButtonClick);

    document.addEventListener('click', (evt) => {
      if (evt.target.closest('[data-filter]')) {
        showMoreButton.removeEventListener('click', onCollapseButtonClick);
      }
    });
  }

  // Интеграция Adv.Cace для программ
  function advCaceProgram() {
    let targetUrl = location.href.split('/');

    //Включаем на странице программ и передаем имя программы
    if (!targetUrl.includes('program')) {
      return;
    }

    try {
      const title = document.querySelector('h1')?.textContent,
        programName = title.split(' ')[1];

      window.advcake_data = window.advcake_data || [];
      window.advcake_data.push({
        pageType: 2,
        user: {
          email: '',
        },
        currentLead: {
          leadid: '',
          name: programName,
        },
      });
    } catch (e) {
      console.log(e);
    }
  }
};

export default site;
